module.exports = __webpack_public_path__ + "img/carrot-swap.86066c46.svg";